import store from '../../../store'

// get default data from config file
import configData from '../../../config'

const loadSuggestions = (params) => {
  store.dispatch('LOAD_SUGGESTIONS', params)
}

const setActiveMouse = (number) => {
  store.commit('SET_ACTIVE_MOUSE', number)
}

const setActiveSuggestTmp = (value) => {
  store.commit('SET_ACTIVE_SUGGEST_TMP', value)
}

const setIsActiveSuggestions = (b) => {
  store.commit('SET_IS_ACTIVE_SUGGESTIONS', b)
}

const setIsActiveAutocompleteDropdown = (b) => {
  store.commit('SET_IS_ACTIVE_AUTOCOMPLETE_DROPDOWN', b)
}

const resetSuggestions = () => {
  store.commit('RESET_SUGGESTIONS')
}

export {
  loadSuggestions,
  setActiveMouse,
  setActiveSuggestTmp,
  setIsActiveSuggestions,
  setIsActiveAutocompleteDropdown,
  resetSuggestions
}



// WEBPACK FOOTER //
// ./src/scripts/modules/store/autocompleteStore-setters.js